export default class GetAllTradeHistoryDTO {
  constructor(
    public account_id: ID,
    public after?: string,
    public open_from?: number,
    public open_to?: number,
    public close_from?: number,
    public close_to?: number
  ) {}
}
